<template>
	<div>
		<div class="card" v-if="isStopStatusCake">
			<!-- Show the loader when async operation is going on -->
            <div class="customer-list-info" v-if="paginatedGroups.length === 0">
                <div class="card-text text-center text-danger mb-3 font-weight-bold">
                    Status Cake is off at the moment!
                </div>
            </div>
		</div>
		<div v-else>
      <section v-if="loading">
        <div class="loader"></div>
      </section>
      <section v-else>
        <div v-if="datatableId==='datatableRecentOutage'" class="row group-section mb-1">
          <template>
            <div class="col-md-4 lh-3">
              <template>
                Down: <span class="badge badge-danger mr-2">{{totalDownTests}}</span>
                Paused: <span class="badge badge-warning mr-2">{{totalPausedTests}}</span>
                Total: <span class="badge badge-success"> {{tests.length}}</span>
              </template>
            </div>
            <div class="col-md-4 lh-3 text-center">
              Affected Nodes:
              <button @click="openAffectedNodesAndRacksModal('node')" class="btn btn-primary btn-sm mr-3 text-right" title="View nodes" ><i class="fa fa-eye"></i></button>

            </div>
            <div class="col-md-4 lh-3 text-right">
              Affected Racks:
              <button @click="openAffectedNodesAndRacksModal('rack')" class="btn btn-primary btn-sm mr-3 text-right" title="View racks" ><i class="fa fa-eye"></i></button>

            </div>
          </template>
        </div>
        <div class="row group-section mb-1" v-for="group in getNonWPOGroup" :key="group.planName">
          <template>
            <div class="col-md-1">
              <span :class="{ 'details-control shown' : group.showTests, 'details-control' : !group.showTests }" @click="renderDatatable(group)"></span>
            </div>
            <div class="col-md-7 lh-3">
              <b>
                <span>{{group.planName==='(N/A)' ? 'Not in WPO' : group.planName }}</span>
              </b>
              <span class="ml-1" v-if="group.planName !== '(N/A)'">
						Server IP:
            <b>{{group.serverIp}}</b>
            </span>
            </div>
            <!--					<div class="col-md-4 text-center lh-3">-->
            <!--						<template  v-if="status === 'Down'">-->
            <!--							Down: <span class="badge badge-danger mr-3">{{group.downCount}}</span>-->
            <!--							Paused: <span class="badge badge-warning mr-3">{{group.pauseCount}}</span>-->
            <!--							Total: <span class="badge badge-success"> {{group.tests.length}}</span>-->
            <!--						</template>-->
            <!--						<template v-else>-->
            <!--							Total Recent Outages: <b>{{group.tests.length}}</b>-->
            <!--						</template>-->
            <!--					</div>-->
            <div class="col-md-4 text-right lh-3">
              <template  v-if="status === 'Down'">
                <span title="Down" class="badge badge-danger mr-2 cursor-pointer">{{group.downCount}}</span>
                <span title="Paused" class="badge badge-warning mr-2 cursor-pointer">{{group.pauseCount}}</span>
                <span title="Total" class="badge badge-success cursor-pointer"> {{group.tests.length}}</span>
              </template>
              <template v-else>
                <span title="Total Recent Outages" class="badge badge-success cursor-pointer"> {{group.tests.length}}</span>

                <!--              Total Recent Outages: <b>{{group.tests.length}}</b>-->
              </template>
              <!--						<button v-if="group.uid"  class="btn btn-primary btn-sm mr-3 ml-3 text-right" title="Login User" @click="findUser(group)"><i class="fa fa-user"></i></button>-->
              <!--						<router-link v-if="group.uid"  class="btn btn-primary btn-sm text-right"  title="Edit User" :to="{ name: 'editUser', params: { docID: group.uid } }"><i class="fa fa-pencil"></i></router-link>-->
            </div>
            <div class="col-md-12" v-show="group.showTests">
              <table :id="group.planName==='(N/A)' ? `${datatableId}-unavailable` : `${datatableId}-${group.planName.split('.')[0]}`" class="table table-striped single-outage-table">
                <thead>
                <tr class="text-center">
                  <th></th>
                  <!--								<th>Test ID</th>-->
                  <th>Status</th>
                  <th>Test Name</th>
                  <th>Server IP</th>
                  <th>Downtime</th>
                  <th>Outages</th>
                  <!--								<th>Status Code</th>-->
                  <!--								<th>Uptime</th>-->
                  <th width="11%">Note</th>
                  <th>Ticket</th>
                  <th>Node</th>
                  <th>Rack</th>
                  <th>Test</th>
                  <!--								<th width="12%">Action</th>-->
                </tr>
                </thead>
                <tbody>
                <tr v-for="test in group.tests" :key="test.testId" :data-id="test.testId">
                  <td width="2%">
                    <div class="dropdown">
                      <button title="Choose Operation" class="btn btn-secondary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-cog"></i>
                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                        <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test, 'viewEventsModal')">View Details</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="remove(test, group)">Delete</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test, 'addNoteModal')">Add Notes</a>
                        <a v-if="group.uid" class="dropdown-item" href="javascript:void(0)" @click=" findUser(group)">Login User</a>
                        <a v-if="group.uid" class="dropdown-item" href="javascript:void(0)" @click=" openTicketModal(test)">Create Ticket</a>
                        <router-link v-if="group.uid" class="dropdown-item" :to="{ name: 'editUser', params: { docID: group.uid || test.uid } }">Edit User</router-link>

                      </div>
                    </div>
                  </td>
                  <!--								<td width="3%">-->
                  <!--									<button class="btn btn-info btn-sm" @click="openModal(test, 'viewEventsModal')"><i class="fa fa-eye"></i></button>-->
                  <!--								</td>-->
                  <!--								<td class="text-center">{{ test.testId }}</td>-->
                  <td width="1%" class="text-center">
                    <div @click="openModal(test, 'changeLiveStatusModal')" :class="{'sc-status': true, 'down': test.status === 'Down', 'up': test.status === 'Up', 'pause': test.status === 'Paused'}"></div>
                  </td>
                  <td class="text-center"><a :href="test.URL" target="_blank">{{test.URL.includes('https://') ? test.URL.split('https://')[1] : test.URL}}</a></td>
                  <td width="3%" class="text-center" @click="doCopy(test.serverIP)">{{ test.serverIP }}</td>
                  <template v-if="status === 'Up'">
                    <td width="3%"  class="text-center">
                      {{timeDifferenceBetweenGivenDates(test.events[test.events.length-1].start, test.events[test.events.length-2].start)}}
                    </td>
                  </template>
                  <template v-else>
                    <td width="3%"  class="text-center">
                      {{domainDateTime[test.URL]}}
                    </td>
                  </template>
                  <td width="1%" class="text-center">{{test.downCount}}</td>
                  <!--								<td class="text-center">{{test.events[test.events.length-1].statusCode}}</td>-->
                  <!--								<td class="text-center">{{test.upTime}}</td>-->
                  <td width="13%" class="cursor-pointer" @click="openModal(test, 'addNoteModal')" :title="test.note">{{(test.note && test.note !== '') ? test.note.substring(0, 20) : 'N/A'}}</td>
                  <td width="3%" class="text-center">
                    <i @click="openModal(test, 'addTicketModal')" title="Edit ticket" class="text-primary fa fa-pencil cursor-pointer"></i>
                    <a v-if="test.ticket_url" :href="test.ticket_url" target="_blank">
                      <i  title="View Ticket" :class="test.ticket_url ? 'text-primary' : 'text-muted'" class=" fa fa-eye ml-2"></i>
                    </a>
                  </td>
                  <td width="3%">{{ (allNodes[`${test.nodeId}`]) ? allNodes[`${test.nodeId}`].nodeName || '' : '' }}</td>
                  <td width="2%">{{ (allNodes[`${test.nodeId}`]) ? getRackName(allNodes[`${test.nodeId}`].rack_name) || '' : ''}}</td>
                  <td width="10%">
                    <select style="height: 31px" class="form-control" @change="updateStatusCakeValue(test, $event)">
                      <option></option>
                      <option :selected="(test.statusCake === undefined && (test.status === 'Up' || test.status === 'Down')) ? true : test.statusCake === 'Active'" value="Active">Active</option>
                      <option :selected="test.statusCake === 'Moved'" value="Moved">Moved</option>
                      <option :selected="(test.statusCake === undefined && test.status === 'Paused') ? true : test.statusCake === 'Suspended'" value="Suspended">Suspended</option>
                      <option :selected="test.statusCake === 'Domain Expired'" value="Domain Expired">Domain Expired</option>
                      <option :selected="test.statusCake === 'Other'" value="Other">Other</option>
                    </select>
                  </td>
                  <!--								<td width="12%" class="text-center">-->
                  <!--									<button class="btn btn-warning btn-sm mr-1" :disabled="action" @click="pause(test ,1)">-->
                  <!--										<div class="loader mini_loader" v-if="updateItem && test.testId === updateItem.testId && action === 'update'"></div>-->
                  <!--										<i v-else class="fa fa-pause"></i>-->
                  <!--									</button>-->
                  <!--									<button class="btn btn-danger btn-sm mr-1" :disabled="action"  @click="remove(test)">-->
                  <!--										<div class="loader mini_loader" v-if="removeItem && test.testId === removeItem.testId && action === 'remove'"></div>-->
                  <!--										<i v-else class="fa fa-trash"></i>-->
                  <!--									</button>-->
                  <!--									<button class="btn btn-info btn-sm" @click="openModal(test, 'addNoteModal')">-->
                  <!--										<i class="fa fa-file-text-o"></i>-->
                  <!--									</button>-->
                  <!--								</td>-->
                </tr>
                </tbody>
              </table>
            </div>
          </template>
          <!--				<template v-else>-->
          <!--					<div class="col-md-12">-->
          <!--						<table class="table table-striped single-outage-table">-->
          <!--							<thead>-->
          <!--								<tr class="text-center">-->
          <!--									<th ></th>-->
          <!--									<th>Test ID</th>-->
          <!--									<th>Status</th>-->
          <!--									<th>Test Name</th>-->
          <!--									<th>Server IP</th>-->
          <!--									<th>Downtime</th>-->
          <!--									<th>Primary Domain</th>-->
          <!--									<th>Outages</th>-->
          <!--&lt;!&ndash;									<th>Status Code</th>&ndash;&gt;-->
          <!--&lt;!&ndash;									<th>Uptime</th>&ndash;&gt;-->
          <!--									<th width="11%">Note</th>-->
          <!--                  <th>Node</th>-->
          <!--                  <th>Rack</th>-->
          <!--									<th>Test</th>-->
          <!--&lt;!&ndash;									<th width="12%">Action</th>&ndash;&gt;-->
          <!--								</tr>-->
          <!--							</thead>-->
          <!--							<tbody>-->
          <!--								<tr v-for="test in group.tests" :key="test.testId" :data-id="test.testId">-->
          <!--                  <td >-->
          <!--                    <div class="dropdown">-->
          <!--                      <button title="Choose Operation" class="btn btn-secondary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
          <!--                        <i class="fa fa-cog"></i>-->
          <!--                      </button>-->
          <!--                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">-->
          <!--                        <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test, 'viewEventsModal')">View Details</a>-->
          <!--                        <a class="dropdown-item" href="javascript:void(0)" @click="findUser(group)">Login User</a>-->
          <!--                        <router-link v-if="group.uid" class="dropdown-item" :to="{ name: 'editUser', params: { docID: group.uid } }">Edit User</router-link>-->
          <!--                        <a class="dropdown-item" href="javascript:void(0)" @click="remove(test)">Delete</a>-->
          <!--                        <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test, 'addNoteModal')">Add Notes</a>-->

          <!--                       </div>-->
          <!--                    </div>-->
          <!--                  </td>-->
          <!--&lt;!&ndash;								<td width="10%">&ndash;&gt;-->
          <!--&lt;!&ndash;									<button class="btn btn-info btn-sm mr-1" @click="openModal(test, 'viewEventsModal')"><i class="fa fa-eye"></i></button>&ndash;&gt;-->
          <!--&lt;!&ndash;									<button class="btn btn-primary btn-sm mr-1" title="Login User" @click="findUser(group)"><i class="fa fa-user"></i></button>&ndash;&gt;-->
          <!--&lt;!&ndash;									<router-link v-if="group.uid" class="btn btn-primary btn-sm"  title="Edit User" :to="{ name: 'editUser', params: { docID: group.uid } }"><i class="fa fa-pencil"></i></router-link>&ndash;&gt;-->
          <!--&lt;!&ndash;								</td>&ndash;&gt;-->
          <!--								<td class="text-center">{{ test.testId }}</td>-->
          <!--								<td class="text-center">-->
          <!--									<div @click="openModal(test, 'changeLiveStatusModal')" :class="{'sc-status': true, 'down': test.status === 'Down', 'up': test.status === 'Up', 'pause': test.status === 'Paused'}"></div>-->
          <!--								</td>-->
          <!--								<td class="text-center"><a :href="test.URL" target="_blank">{{test.URL}}</a></td>-->
          <!--								<td class="text-center">{{ test.serverIP }}</td>-->
          <!--                  <template v-if="status === 'Up'">-->
          <!--									<td class="text-center">-->
          <!--										{{timeDifferenceBetweenGivenDates(test.events[test.events.length-1].start, test.events[test.events.length-2].start)}}-->
          <!--									</td>-->
          <!--								</template>-->
          <!--								<template v-else>-->
          <!--									<td class="text-center">-->
          <!--										{{domainDateTime[test.URL]}}-->
          <!--									</td>-->
          <!--								</template>-->
          <!--								<td class="text-center">{{group.planName}}</td>-->
          <!--								<td class="text-center">{{test.downCount}}</td>-->
          <!--&lt;!&ndash;								<td class="text-center">{{test.events[test.events.length-1].statusCode}}</td>&ndash;&gt;-->
          <!--&lt;!&ndash;								<td class="text-center">{{test.upTime}}</td>&ndash;&gt;-->
          <!--								<td width="11%" class="" :title="test.note">{{(test.note && test.note !== '') ? test.note.substring(0, 20) : 'N/A'}}</td>-->
          <!--                  <td>{{ (allNodes[`${test.nodeId}`]) ? allNodes[`${test.nodeId}`].nodeName || '' : '' }}</td>-->
          <!--                  <td>{{ (allNodes[`${test.nodeId}`]) ? allNodes[`${test.nodeId}`].rack_name || '' : ''}}</td>-->
          <!--                <td width="13%">-->
          <!--									<select class="form-control" @change="updateStatusCakeValue(test, $event)">-->
          <!--										<option></option>-->
          <!--										<option :selected="(test.statusCake === undefined && (test.status === 'Up' || test.status === 'Down')) ? true : test.statusCake === 'Active'" value="Active">Active</option>-->
          <!--										<option :selected="test.statusCake === 'Moved'" value="Moved">Moved</option>-->
          <!--										<option :selected="(test.statusCake === undefined && test.status === 'Paused') ? true : test.statusCake === 'Suspended'" value="Suspended">Suspended</option>-->
          <!--										<option :selected="test.statusCake === 'Domain Expired'" value="Domain Expired">Domain Expired</option>-->
          <!--										<option :selected="test.statusCake === 'Other'" value="Other">Other</option>-->
          <!--									</select>-->
          <!--								</td>-->
          <!--&lt;!&ndash;								<td width="12%" class="text-center">&ndash;&gt;-->
          <!--&lt;!&ndash;									<button class="btn btn-warning btn-sm mr-1" :disabled="action" @click="pause(test ,1)">&ndash;&gt;-->
          <!--&lt;!&ndash;										<div class="loader mini_loader" v-if="updateItem && test.testId === updateItem.testId && action === 'update'"></div>&ndash;&gt;-->
          <!--&lt;!&ndash;										<i v-else class="fa fa-pause"></i>&ndash;&gt;-->
          <!--&lt;!&ndash;									</button>&ndash;&gt;-->
          <!--&lt;!&ndash;									<button class="btn btn-danger btn-sm mr-1" :disabled="action"  @click="remove(test)">&ndash;&gt;-->
          <!--&lt;!&ndash;										<div class="loader mini_loader" v-if="removeItem && test.testId === removeItem.testId && action === 'remove'"></div>&ndash;&gt;-->
          <!--&lt;!&ndash;										<i v-else class="fa fa-trash"></i>&ndash;&gt;-->
          <!--&lt;!&ndash;									</button>&ndash;&gt;-->
          <!--&lt;!&ndash;									<button class="btn btn-info btn-sm mr-3" @click="openModal(test, 'addNoteModal')">&ndash;&gt;-->
          <!--&lt;!&ndash;										<i class="fa fa-file-text-o"></i>&ndash;&gt;-->
          <!--&lt;!&ndash;									</button>&ndash;&gt;-->
          <!--&lt;!&ndash;								</td>&ndash;&gt;-->
          <!--							</tr>-->
          <!--							</tbody>-->
          <!--						</table>-->
          <!--					</div>-->
          <!--				</template>-->
        </div>
        <div class="row group-section mb-1 " >
          <template>
            <!--					<div class="col-md-1">-->
            <!--						<span :class="{ 'details-control shown' : group.showTests, 'details-control' : !group.showTests }" @click="renderDatatable(group)"></span>-->
            <!--					</div>-->
            <!--					<div v-if="group.ungrouped" class="col-md-4 lh-3">-->
            <!--						<b>Un-Grouped Tests</b>-->

            <!--					</div>-->
            <!--          <div v-else class="col-md-4 lh-3">-->
            <!--						Plan's Primary Domain:-->
            <!--						<b>-->
            <!--							<span>{{group.planName==='(N/A)' ? '(Not in WPO)' : group.planName }}</span>-->
            <!--						</b>-->
            <!--            <span class="ml-2" v-if="group.planName !== '(N/A)'">-->
            <!--						Server IP:-->
            <!--            <b>{{group.serverIp}}</b>-->
            <!--            </span>-->
            <!--					</div>-->
            <!--					<div class="col-md-4 text-center lh-3">-->
            <!--						<template  v-if="status === 'Down'">-->
            <!--							Down: <span class="badge badge-danger mr-3">{{group.downCount}}</span>-->
            <!--							Paused: <span class="badge badge-warning mr-3">{{group.pauseCount}}</span>-->
            <!--							Total: <span class="badge badge-success"> {{group.tests.length}}</span>-->
            <!--						</template>-->
            <!--						<template v-else>-->
            <!--							Total Recent Outages: <b>{{group.tests.length}}</b>-->
            <!--						</template>-->
            <!--					</div>-->
            <!--					<div class="col-md-3 text-right">-->
            <!--						<button v-if="group.uid" class="btn btn-primary btn-sm mr-3" title="Login User" @click="findUser(group)"><i class="fa fa-user"></i></button>-->
            <!--						<router-link v-if="group.uid" class="btn btn-primary btn-sm"  title="Edit User" :to="{ name: 'editUser', params: { docID: group.uid } }"><i class="fa fa-pencil"></i></router-link>-->
            <!--					</div>-->
            <div class="col-md-12 mt-2">
              <label> Show
                <select class="custom-select custom-select-sm form-control form-control-sm datatable-dropdown" id="grouped"  aria-describedby="grouped" required v-model="pageSize">
                  <option value="10" >10</option>
                  <option value="25" >25</option>
                  <option value="50" >50</option>
                  <option :value="paginatedGroups.length" >All</option>
              </select> entries</label>
            </div>
            <div class="col-md-12 mt-2">
              <table :id="`${datatableId}-ungrouped`" class="table table-striped single-outage-table ">
                <thead>
                <tr class="text-center">
                  <th></th>
                  <!--								<th>Test ID</th>-->
                  <th>Status
<!--                    <i v-if="!statusSortType || statusSortType==='desc'" class="fa fa-sort-down" :class="statusSortType==='desc' ? 'text-primary': 'text-muted'" @click="clickedStatusSort()" />-->
<!--                    <i v-if="!statusSortType || statusSortType==='asc'"  class="fa fa-sort-up " :style="!statusSortType?'margin-left:-7px':'' "  :class="statusSortType==='asc' ? 'text-primary': 'text-muted'" @click="clickedStatusSort()" />-->

                  </th>
                  <th>Test Name
                    <i v-if="!planSortType || planSortType==='desc'" class="fa fa-sort-down" :class="planSortType==='desc' ? 'text-primary': 'text-muted'" @click="clickedPlanSort()" />
                    <i v-if="!planSortType || planSortType==='asc'"  class="fa fa-sort-up " :style="!planSortType?'margin-left:-7px':'' "  :class="planSortType==='asc' ? 'text-primary': 'text-muted'" @click="clickedPlanSort()" />
                  </th>
                  <th>Server IP
                    <i v-if="!ipSortType || ipSortType==='desc'" class="fa fa-sort-down" :class="ipSortType==='desc' ? 'text-primary': 'text-muted'" @click="clickedIpSort()" />
                    <i v-if="!ipSortType || ipSortType==='asc'"  class="fa fa-sort-up " :style="!ipSortType?'margin-left:-7px':'' "  :class="ipSortType==='asc' ? 'text-primary': 'text-muted'" @click="clickedIpSort()" />
                  </th>
                  <th>Downtime</th>
                  <th>Outages
                    <i v-if="!outageSortType || outageSortType==='desc'" class="fa fa-sort-down" :class="outageSortType==='desc' ? 'text-primary': 'text-muted'" @click="clickedOutageSort()" />
                    <i v-if="!outageSortType || outageSortType==='asc'"  class="fa fa-sort-up " :style="!outageSortType?'margin-left:-7px':'' "  :class="outageSortType==='asc' ? 'text-primary': 'text-muted'" @click="clickedOutageSort()" />
                  </th>
                  <!--								<th>Status Code</th>-->
                  <!--								<th>Uptime</th>-->
                  <th width="18%">Note</th>
                  <th>Ticket</th>
                  <th>Node
                    <i v-if="!nodeSortType || nodeSortType==='desc'" class="fa fa-sort-down" :class="nodeSortType==='desc' ? 'text-primary': 'text-muted'" @click="clickedNodeSort()" />
                    <i v-if="!nodeSortType || nodeSortType==='asc'"  class="fa fa-sort-up " :style="!nodeSortType?'margin-left:-7px':'' "  :class="nodeSortType==='asc' ? 'text-primary': 'text-muted'" @click="clickedNodeSort()" />
                  </th>
                  <th>Rack
                    <i v-if="!rackSortType || rackSortType==='desc'" class="fa fa-sort-down" :class="rackSortType==='desc' ? 'text-primary': 'text-muted'" @click="clickedRackSort()" />
                    <i v-if="!rackSortType || rackSortType==='asc'"  class="fa fa-sort-up " :style="!rackSortType?'margin-left:-7px':'' "  :class="rackSortType==='asc' ? 'text-primary': 'text-muted'" @click="clickedRackSort()" />
                  </th>
                  <th>Test</th>
                  <!--								<th width="12%">Action</th>-->
                </tr>
                </thead>
                <tbody  v-for="group in getWPOGroup" :key="group.planName">
                <tr v-if="group.tests.length > 1">
                  <td>
                    <span :class="{ 'details-control shown' : group.showTests, 'details-control' : !group.showTests }" @click="renderDatatable(group)"></span>

                  </td>
                  <td class="text-center" width="10%">
                    <template  v-if="status === 'Down'">
                      <span title="Down" class="badge badge-danger p-4-4">{{group.downCount}}</span>
                      <span title="Paused" class="badge badge-warning p-4-4">{{group.pauseCount}}</span>
                      <span title="Total" class="badge badge-success p-4-4"> {{group.tests.length}}</span>
                    </template>
                    <template v-else>
                      <span title="Total Recent Outages" class="badge badge-success"> {{group.tests.length}}</span>
                      <!--                    Total Recent Outages: <b>{{group.tests.length}}</b>-->
                    </template>
                  </td>
                  <td class="text-center"><b>
                    {{group.planName==='(N/A)' ? 'Not in WPO' : group.planName }}
                  </b></td>
                  <td> <span class="ml-1" v-if="group.planName !== '(N/A)'">
                      <b>{{group.serverIp}}</b>
                    </span></td>
                  <td></td>
                  <td width="11%" class="text-center">{{getTotalOutages(group)}}</td>
                  <td></td>
                  <td></td>
                  <td width="3%">{{ (allNodes[`${group.tests[0].nodeId}`]) ? allNodes[`${group.tests[0].nodeId}`].nodeName || '' : '' }}</td>
                  <td width="7%" class="text-center">{{ (allNodes[`${group.tests[0].nodeId}`]) ? getRackName(allNodes[`${group.tests[0].nodeId}`].rack_name) || '' : ''}}</td>

                  <td class="text-center">
<!--                    <template  v-if="status === 'Down'">-->
<!--                    <span title="Down" class="badge badge-danger mr-1">{{group.downCount}}</span>-->
<!--                    <span title="Paused" class="badge badge-warning mr-1">{{group.pauseCount}}</span>-->
<!--                    <span title="Total" class="badge badge-success"> {{group.tests.length}}</span>-->
<!--                  </template>-->
<!--                    <template v-else>-->
<!--                      <span title="Total Recent Outages" class="badge badge-success"> {{group.tests.length}}</span>-->
<!--                      &lt;!&ndash;                    Total Recent Outages: <b>{{group.tests.length}}</b>&ndash;&gt;-->
<!--                    </template>-->
                    <!--                  <button v-if="group.uid"  class="btn btn-primary btn-sm mr-3 ml-3 text-right" title="Login User" @click="findUser(group)"><i class="fa fa-user"></i></button>-->
                    <!--                  <router-link v-if="group.uid"  class="btn btn-primary btn-sm text-right"  title="Edit User" :to="{ name: 'editUser', params: { docID: group.uid } }"><i class="fa fa-pencil"></i></router-link>-->
                  </td>
                </tr>
                <tr v-else-if="group.tests.length==1">
                  <td width="2%">
                    <div class="dropdown">
                      <button title="Choose Operation" class="btn btn-secondary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-cog"></i>
                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                        <a class="dropdown-item" href="javascript:void(0)" @click="openModal(group.tests[0], 'viewEventsModal')">View Details</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="remove(group.tests[0], group)">Delete</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="openModal(group.tests[0], 'addNoteModal')">Add Notes</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click=" findUser(group)">Login User</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="openTicketModal(group.tests[0])">Create Ticket</a>
                        <router-link v-if="group.uid " class="dropdown-item" :to="{ name: 'editUser', params: { docID: group.uid || group.tests[0].uid } }">Edit User</router-link>

                      </div>
                    </div>
                  </td>
                  <!--								<td width="3%">-->
                  <!--									<button class="btn btn-info btn-sm" @click="openModal(test, 'viewEventsModal')"><i class="fa fa-eye"></i></button>-->
                  <!--								</td>-->
                  <!--                  <td class="text-center">{{ group.tests[0].testId }}</td>-->
                  <td width="10%" class="text-center">
                    <div @click="openModal(group.tests[0], 'changeLiveStatusModal')" :class="{'sc-status': true, 'down': group.tests[0].status === 'Down', 'up': group.tests[0].status === 'Up', 'pause': group.tests[0].status === 'Paused'}"></div>
                  </td>
                  <td class="text-center"><a :href="group.tests[0].URL" target="_blank">{{group.tests[0].URL.includes('https://') ? group.tests[0].URL.split('https://')[1] : group.tests[0].URL}}</a></td>
                  <td width="3%" @click="doCopy(group.tests[0].serverIP)" class="text-center">{{ group.tests[0].serverIP }}</td>
                  <template v-if="status === 'Up'">
                    <td width="3%" class="text-center">
                      {{timeDifferenceBetweenGivenDates(group.tests[0].events[group.tests[0].events.length-1].start, group.tests[0].events[group.tests[0].events.length-2].start)}}
                    </td>
                  </template>
                  <template v-else>
                    <td width="3%" class="text-center">
                      {{domainDateTime[group.tests[0].URL]}}
                    </td>
                  </template>
                  <td width="11%" class="text-center">{{group.tests[0].downCount}}</td>
                  <!--								<td class="text-center">{{test.events[test.events.length-1].statusCode}}</td>-->
                  <!--								<td class="text-center">{{test.upTime}}</td>-->
                  <td width="18%" class="cursor-pointer" @click="openModal(group.tests[0], 'addNoteModal')" :title="getNoteTooltip(group.tests[0])">
                    {{(group.tests[0].note && group.tests[0].note !== '') ? group.tests[0].note: 'N/A'}}
                  </td>
                  <td width="3%" class="text-center">
                    <i @click="openModal(group.tests[0], 'addTicketModal')" title="Edit ticket" class="text-primary fa fa-pencil cursor-pointer"></i>
                    <a v-if="group.tests[0].ticket_url" :href="group.tests[0].ticket_url" target="_blank">
                      <i  title="View Ticket" :class="group.tests[0].ticket_url ? 'text-primary' : 'text-muted'" class=" fa fa-eye ml-2"></i>
                    </a>
                  </td>
                  <td width="3%">{{ (allNodes[`${group.tests[0].nodeId}`]) ? allNodes[`${group.tests[0].nodeId}`].nodeName || '' : '' }}</td>
                  <td width="2%" class="text-center">{{ (allNodes[`${group.tests[0].nodeId}`]) ? getRackName(allNodes[`${group.tests[0].nodeId}`].rack_name) || '' : ''}}</td>
                  <td width="10%">
                    <select style="height: 31px" class="form-control" @change="updateStatusCakeValue(group.tests[0], $event)">
                      <option></option>
                      <option :selected="(group.tests[0].statusCake === undefined && (group.tests[0].status === 'Up' || group.tests[0].status === 'Down')) ? true : group.tests[0].statusCake === 'Active'" value="Active">Active</option>
                      <option :selected="group.tests[0].statusCake === 'Moved'" value="Moved">Moved</option>
                      <option :selected="(group.tests[0].statusCake === undefined && group.tests[0].status === 'Paused') ? true : group.tests[0].statusCake === 'Suspended'" value="Suspended">Suspended</option>
                      <option :selected="group.tests[0].statusCake === 'Domain Expired'" value="Domain Expired">Domain Expired</option>
                      <option :selected="group.tests[0].statusCake === 'Other'" value="Other">Other</option>
                    </select>
                  </td>
                  <!--								<td width="12%" class="text-center">-->
                  <!--									<button class="btn btn-warning btn-sm mr-1" :disabled="action" @click="pause(test ,1)">-->
                  <!--										<div class="loader mini_loader" v-if="updateItem && test.testId === updateItem.testId && action === 'update'"></div>-->
                  <!--										<i v-else class="fa fa-pause"></i>-->
                  <!--									</button>-->
                  <!--									<button class="btn btn-danger btn-sm mr-1" :disabled="action"  @click="remove(test)">-->
                  <!--										<div class="loader mini_loader" v-if="removeItem && test.testId === removeItem.testId && action === 'remove'"></div>-->
                  <!--										<i v-else class="fa fa-trash"></i>-->
                  <!--									</button>-->
                  <!--									<button class="btn btn-info btn-sm" @click="openModal(test, 'addNoteModal')">-->
                  <!--										<i class="fa fa-file-text-o"></i>-->
                  <!--									</button>-->
                  <!--								</td>-->
                </tr>
                <tr style="background-color: rgba(251,198, 88, 0.1)"  v-show="group.showTests" v-for="test in (group.tests)" :key="test.testId" :data-id="test.testId">
                  <td width="2%">
                    <div class="dropdown">
                      <button title="Choose Operation" class="btn btn-secondary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-cog"></i>
                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                        <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test, 'viewEventsModal')">View Details</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="remove(test, group)">Delete</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test, 'addNoteModal')">Add Notes</a>
                        <a v-if="group.uid" class="dropdown-item" href="javascript:void(0)" @click=" findUser(group)">Login User</a>
                        <a v-if="group.uid" class="dropdown-item" href="javascript:void(0)" @click="openTicketModal(test)">Create Ticket</a>
                        <router-link v-if="group.uid" class="dropdown-item" :to="{ name: 'editUser', params: { docID: group.uid || test.uid } }">Edit User</router-link>

                      </div>
                    </div>
                  </td>

                  <td width="10%" class="text-center">
                    <div @click="openModal(test, 'changeLiveStatusModal')" :class="{'sc-status': true, 'down': test.status === 'Down', 'up': test.status === 'Up', 'pause': test.status === 'Paused'}"></div>
                  </td>
                  <td class="text-center"><a :href="test.URL" target="_blank">{{test.URL.includes('https://') ? test.URL.split('https://')[1] : test.URL}}</a></td>
                  <td width="3%" class="text-center" @click="doCopy(test.serverIP)">{{ test.serverIP }}</td>
                  <template v-if="status === 'Up'">
                    <td width="3%"  class="text-center">
                      {{timeDifferenceBetweenGivenDates(test.events[test.events.length-1].start, test.events[test.events.length-2].start)}}
                    </td>
                  </template>
                  <template v-else>
                    <td width="3%"  class="text-center">
                      {{domainDateTime[test.URL]}}
                    </td>
                  </template>
                  <td width="11%" class="text-center">{{test.downCount}}</td>
                  <!--								<td class="text-center">{{test.events[test.events.length-1].statusCode}}</td>-->
                  <!--								<td class="text-center">{{test.upTime}}</td>-->
                  <td width="18%" class="cursor-pointer" @click="openModal(test, 'addNoteModal')" :title="getNoteTooltip(test)">{{(test.note && test.note !== '') ? test.note.substring(0, 20) : 'N/A'}}</td>
                  <td width="3%" class="text-center">
                    <i @click="openModal(test, 'addTicketModal')" title="Edit ticket" class="text-primary fa fa-pencil cursor-pointer"></i>
                    <a  v-if="test.ticket_url" :href="test.ticket_url" target="_blank">
                      <i title="View Ticket" :class="test.ticket_url ? 'text-primary' : 'text-muted'" class=" fa fa-eye ml-2"></i>
                    </a>
                  </td>
                  <td width="3%">{{ (allNodes[`${test.nodeId}`]) ? allNodes[`${test.nodeId}`].nodeName || '' : '' }}</td>
                  <td width="2%">{{ (allNodes[`${test.nodeId}`]) ? getRackName(allNodes[`${test.nodeId}`].rack_name) || '' : ''}}</td>

                  <td width="10%">
                    <select style="height: 31px" class="form-control" @change="updateStatusCakeValue(test, $event)">
                      <option></option>
                      <option :selected="(test.statusCake === undefined && (test.status === 'Up' || test.status === 'Down')) ? true : test.statusCake === 'Active'" value="Active">Active</option>
                      <option :selected="test.statusCake === 'Moved'" value="Moved">Moved</option>
                      <option :selected="(test.statusCake === undefined && test.status === 'Paused') ? true : test.statusCake === 'Suspended'" value="Suspended">Suspended</option>
                      <option :selected="test.statusCake === 'Domain Expired'" value="Domain Expired">Domain Expired</option>
                      <option :selected="test.statusCake === 'Other'" value="Other">Other</option>
                    </select>
                  </td>
                </tr>
                </tbody>
                <!--							<tbody>-->
                <!--							</tbody>-->
              </table>
            </div>
          </template>
          <!--				<template v-else>-->
          <!--					<div class="col-md-12">-->
          <!--						<table class="table table-striped single-outage-table">-->
          <!--							<thead>-->
          <!--								<tr class="text-center">-->
          <!--									<th ></th>-->
          <!--									<th>Test ID</th>-->
          <!--									<th>Status</th>-->
          <!--									<th>Test Name</th>-->
          <!--									<th>Server IP</th>-->
          <!--									<th>Downtime</th>-->
          <!--									<th>Primary Domain</th>-->
          <!--									<th>Outages</th>-->
          <!--&lt;!&ndash;									<th>Status Code</th>&ndash;&gt;-->
          <!--&lt;!&ndash;									<th>Uptime</th>&ndash;&gt;-->
          <!--									<th width="11%">Note</th>-->
          <!--                  <th>Node</th>-->
          <!--                  <th>Rack</th>-->
          <!--									<th>Test</th>-->
          <!--&lt;!&ndash;									<th width="12%">Action</th>&ndash;&gt;-->
          <!--								</tr>-->
          <!--							</thead>-->
          <!--							<tbody>-->
          <!--								<tr v-for="test in group.tests" :key="test.testId" :data-id="test.testId">-->
          <!--                  <td >-->
          <!--                    <div class="dropdown">-->
          <!--                      <button title="Choose Operation" class="btn btn-secondary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
          <!--                        <i class="fa fa-cog"></i>-->
          <!--                      </button>-->
          <!--                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">-->
          <!--                        <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test, 'viewEventsModal')">View Details</a>-->
          <!--                        <a class="dropdown-item" href="javascript:void(0)" @click="findUser(group)">Login User</a>-->
          <!--                        <router-link v-if="group.uid" class="dropdown-item" :to="{ name: 'editUser', params: { docID: group.uid } }">Edit User</router-link>-->
          <!--                        <a class="dropdown-item" href="javascript:void(0)" @click="remove(test)">Delete</a>-->
          <!--                        <a class="dropdown-item" href="javascript:void(0)" @click="openModal(test, 'addNoteModal')">Add Notes</a>-->

          <!--                       </div>-->
          <!--                    </div>-->
          <!--                  </td>-->
          <!--&lt;!&ndash;								<td width="10%">&ndash;&gt;-->
          <!--&lt;!&ndash;									<button class="btn btn-info btn-sm mr-1" @click="openModal(test, 'viewEventsModal')"><i class="fa fa-eye"></i></button>&ndash;&gt;-->
          <!--&lt;!&ndash;									<button class="btn btn-primary btn-sm mr-1" title="Login User" @click="findUser(group)"><i class="fa fa-user"></i></button>&ndash;&gt;-->
          <!--&lt;!&ndash;									<router-link v-if="group.uid" class="btn btn-primary btn-sm"  title="Edit User" :to="{ name: 'editUser', params: { docID: group.uid } }"><i class="fa fa-pencil"></i></router-link>&ndash;&gt;-->
          <!--&lt;!&ndash;								</td>&ndash;&gt;-->
          <!--								<td class="text-center">{{ test.testId }}</td>-->
          <!--								<td class="text-center">-->
          <!--									<div @click="openModal(test, 'changeLiveStatusModal')" :class="{'sc-status': true, 'down': test.status === 'Down', 'up': test.status === 'Up', 'pause': test.status === 'Paused'}"></div>-->
          <!--								</td>-->
          <!--								<td class="text-center"><a :href="test.URL" target="_blank">{{test.URL}}</a></td>-->
          <!--								<td class="text-center">{{ test.serverIP }}</td>-->
          <!--                  <template v-if="status === 'Up'">-->
          <!--									<td class="text-center">-->
          <!--										{{timeDifferenceBetweenGivenDates(test.events[test.events.length-1].start, test.events[test.events.length-2].start)}}-->
          <!--									</td>-->
          <!--								</template>-->
          <!--								<template v-else>-->
          <!--									<td class="text-center">-->
          <!--										{{domainDateTime[test.URL]}}-->
          <!--									</td>-->
          <!--								</template>-->
          <!--								<td class="text-center">{{group.planName}}</td>-->
          <!--								<td class="text-center">{{test.downCount}}</td>-->
          <!--&lt;!&ndash;								<td class="text-center">{{test.events[test.events.length-1].statusCode}}</td>&ndash;&gt;-->
          <!--&lt;!&ndash;								<td class="text-center">{{test.upTime}}</td>&ndash;&gt;-->
          <!--								<td width="11%" class="" :title="test.note">{{(test.note && test.note !== '') ? test.note.substring(0, 20) : 'N/A'}}</td>-->
          <!--                  <td>{{ (allNodes[`${test.nodeId}`]) ? allNodes[`${test.nodeId}`].nodeName || '' : '' }}</td>-->
          <!--                  <td>{{ (allNodes[`${test.nodeId}`]) ? allNodes[`${test.nodeId}`].rack_name || '' : ''}}</td>-->
          <!--                <td width="13%">-->
          <!--									<select class="form-control" @change="updateStatusCakeValue(test, $event)">-->
          <!--										<option></option>-->
          <!--										<option :selected="(test.statusCake === undefined && (test.status === 'Up' || test.status === 'Down')) ? true : test.statusCake === 'Active'" value="Active">Active</option>-->
          <!--										<option :selected="test.statusCake === 'Moved'" value="Moved">Moved</option>-->
          <!--										<option :selected="(test.statusCake === undefined && test.status === 'Paused') ? true : test.statusCake === 'Suspended'" value="Suspended">Suspended</option>-->
          <!--										<option :selected="test.statusCake === 'Domain Expired'" value="Domain Expired">Domain Expired</option>-->
          <!--										<option :selected="test.statusCake === 'Other'" value="Other">Other</option>-->
          <!--									</select>-->
          <!--								</td>-->
          <!--&lt;!&ndash;								<td width="12%" class="text-center">&ndash;&gt;-->
          <!--&lt;!&ndash;									<button class="btn btn-warning btn-sm mr-1" :disabled="action" @click="pause(test ,1)">&ndash;&gt;-->
          <!--&lt;!&ndash;										<div class="loader mini_loader" v-if="updateItem && test.testId === updateItem.testId && action === 'update'"></div>&ndash;&gt;-->
          <!--&lt;!&ndash;										<i v-else class="fa fa-pause"></i>&ndash;&gt;-->
          <!--&lt;!&ndash;									</button>&ndash;&gt;-->
          <!--&lt;!&ndash;									<button class="btn btn-danger btn-sm mr-1" :disabled="action"  @click="remove(test)">&ndash;&gt;-->
          <!--&lt;!&ndash;										<div class="loader mini_loader" v-if="removeItem && test.testId === removeItem.testId && action === 'remove'"></div>&ndash;&gt;-->
          <!--&lt;!&ndash;										<i v-else class="fa fa-trash"></i>&ndash;&gt;-->
          <!--&lt;!&ndash;									</button>&ndash;&gt;-->
          <!--&lt;!&ndash;									<button class="btn btn-info btn-sm mr-3" @click="openModal(test, 'addNoteModal')">&ndash;&gt;-->
          <!--&lt;!&ndash;										<i class="fa fa-file-text-o"></i>&ndash;&gt;-->
          <!--&lt;!&ndash;									</button>&ndash;&gt;-->
          <!--&lt;!&ndash;								</td>&ndash;&gt;-->
          <!--							</tr>-->
          <!--							</tbody>-->
          <!--						</table>-->
          <!--					</div>-->
          <!--				</template>-->
        </div>
        <div class="row mt-2" v-if="getWPOGroup.length > 0">
          <div class="col-md-12 text-center">
                    <span class="lh-3 pull-left">
                        Page {{this.pageNumber + 1}} of {{pageCount}}
                    </span>
            <section class="dataTables_paginate paging_full_numbers">
              <paginate
                  :pageCount="pageCount"
                  :clickHandler="goToPage"
                  :prevText="'Prev'"
                  :nextText="'Next'"
                  page-class="page-item"
                  prev-class="page-item"
                  prev-link-class="page-link"
                  next-class="page-item"
                  next-link-class="page-link"
                  page-link-class="page-link"
                  containerClass="pagination">
              </paginate>
            </section>
          </div>
        </div>
        <div class="customer-list-info" v-if="getWPOGroup.length === 0">
          <div class="card-text text-center text-danger mb-3 font-weight-bold">
            No {{(status === 'Up') ? 'Recent' : 'Current'}} Outages Exists!
          </div>
        </div>
      </section>
    </div>
    <affected-nodes-and-racks ref="nodes"/>
	</div>
</template>

<script>
	import loginAsMixin from "../../../mixins/loginAsMixin";
	import swal from "sweetalert2";
	import {db} from "@/firebase/init";
	import _ from "lodash";
	import dateMixin from '../../../mixins/dateMixin'
	import moment from 'moment';
	import { map, find } from 'lodash';
    import Paginate from 'vuejs-paginate'
    export default {
		name: "OutagesTable",
		props: ["datatableId", "status", "presetMacros"],
		mixins: [dateMixin, loginAsMixin],
		components: { Paginate ,affectedNodesAndRacks: () =>
          import(/* webpackChunkName: "userList" */ "../../../components/Admin/Dashboard/affectedNodesAndRacks"),
    },
		data() {
			return {
			  affectedNodes: [],
        affectedRacks: [],
				action: null,
				removeItem: null,
				updateItem: null,
				domainDateTime: {},
				selectedCustomer: {},
                testGroups: [],
                tests: [],
				pageNumber: 0,
				pageSize: 10,
				searchQuery: '',
        allNodes: {},
        totalDownTests: 0,
        totalPausedTests: 0,
        planSortType: null,
        outageSortType: null,
        ipSortType: null,
        nodeSortType: null,
        rackSortType: null,
        statusSortType: 'desc',
        loading: true,
			}
		},
      mounted(){
        this.getAllNodes();
      },
      computed: {

		  getNonWPOGroup(){
		    return this.paginatedGroups.filter(el => el.planName==='(N/A)')
      },
      getWPOGroup(){
		      let array= this.paginatedGroups.filter(el => el.planName!=='(N/A)')
        if(this.planSortType === 'asc'){
          console.log('in type')
          array.sort((a, b) => {
            if (a.planName.toLowerCase() > b.planName.toLowerCase()) {
              return 1
            }
            if (a.planName.toLowerCase() < b.planName.toLowerCase()) {
              return -1
            }
            return 0
          });
        } else if(this.planSortType === 'desc'){
          array.sort(function(a, b){
            if (a.planName.toLowerCase() < b.planName.toLowerCase()) {
              return 1
            }
            if (a.planName.toLowerCase() > b.planName.toLowerCase()) {
              return -1
            }
            return 0
          });
        }
        if(this.nodeSortType === 'asc'){
          console.log('in node sort')
          array.sort((a, b) => {
            if (a.nodeName.toLowerCase() > b.nodeName.toLowerCase()) {
              return 1
            }
            if (a.nodeName.toLowerCase() < b.nodeName.toLowerCase()) {
              return -1
            }
            return 0
          });
        } else if(this.nodeSortType === 'desc'){
          array.sort(function(a, b){
            if (a.nodeName.toLowerCase() < b.nodeName.toLowerCase()) {
              return 1
            }
            if (a.nodeName.toLowerCase() > b.nodeName.toLowerCase()) {
              return -1
            }
            return 0
          });
        }
        if(this.rackSortType === 'asc'){
          console.log('in rack sort')
          array.sort((a, b) => {
            if (a.rackName.toLowerCase() > b.rackName.toLowerCase()) {
              return 1
            }
            if (a.rackName.toLowerCase() < b.rackName.toLowerCase()) {
              return -1
            }
            return 0
          });
        } else if(this.rackSortType === 'desc'){
          array.sort(function(a, b){
            if (a.rackName.toLowerCase() < b.rackName.toLowerCase()) {
              return 1
            }
            if (a.rackName.toLowerCase() > b.rackName.toLowerCase()) {
              return -1
            }
            return 0
          });
        }
        if(this.outageSortType === 'asc'){
          array.sort((a, b) => {
            if (a.downCounts > b.downCounts) {
              return 1
            }
            if (a.downCounts < b.downCounts) {
              return -1
            }
            return 0
          });
        } else if(this.outageSortType === 'desc'){
          array.sort((a, b)=>{
            if (a.downCounts < b.downCounts) {
              return 1
            }
            if (a.downCounts > b.downCounts) {
              return -1
            }
            return 0
          });
        }
        if(this.ipSortType === 'asc'){
          array.sort((a, b) => {
            if (a.serverIp > b.serverIp) {
              return 1
            }
            if (a.serverIp < b.serverIp) {
              return -1
            }
            return 0
          });
        } else if(this.ipSortType === 'desc'){
          array.sort(function(a, b){
            if (a.serverIp < b.serverIp) {
              return 1
            }
            if (a.serverIp > b.serverIp) {
              return -1
            }
            return 0
          });
        }
        if(this.statusSortType === 'asc'){
          array.sort((a, b) => {
            if (a.status > b.status) {
              return 1
            }
            if (a.status < b.status) {
              return -1
            }
            return 0
          });
        } else if(this.statusSortType === 'desc'){
          array.sort(function(a, b){
            if (a.status < b.status) {
              return 1
            }
            if (a.status > b.status) {
              return -1
            }
            return 0
          });
        }

        if (!this.planSortType && !this.statusSortType && !this.ipSortType && !this.rackSortType && !this.nodeSortType && !this.outageSortType) {
          array.sort(function(a, b){
            // ASC  -> a.length - b.length
            // DESC -> b.length - a.length
            return b.tests.length - a.tests.length;
          });
        }

          const start = this.pageNumber * this.pageSize, end = start + this.pageSize;
          return array.slice(start, end);
        },
      isStopStatusCake() {
          return this.$store.getters.getStatusCakeStatus;
      },

			userToken() {
				return this.$store.getters.getUserToken;
			},

			paginatedGroups(){
				let filteredGroups = this.testGroups;
				if(this.searchQuery) {
					filteredGroups = filteredGroups.filter(g => {
						if(g.planName.toLowerCase().includes(this.searchQuery.toLowerCase())){
							return true;
						}
						let isTestInclude = false;
						g.tests.map(t => {
							if(t.URL.toLowerCase().includes(this.searchQuery.toLowerCase())){
								isTestInclude = true;
							}
						});
						return isTestInclude;
					})
				}
        console.log('groups', filteredGroups)

				// const start = this.pageNumber * this.pageSize, end = start + this.pageSize;
        // filteredGroups.sort(function(a, b){
        //   // ASC  -> a.length - b.length
        //   // DESC -> b.length - a.length
        //   return b.tests.length - a.tests.length;
        // });
        return filteredGroups
        // return filteredGroups.slice(start, end);
			},


        // pageCount(){
			// 	let filteredGroups = this.testGroups;
			// 	if(this.searchQuery) {
			// 		filteredGroups = filteredGroups.filter(g => {
			// 			if(g.planName.toLowerCase().includes(this.searchQuery.toLowerCase())){
			// 				return true;
			// 			}
			// 			let isTestInclude = false;
			// 			g.tests.map(t => {
			// 				if(t.URL.toLowerCase().includes(this.searchQuery.toLowerCase())){
			// 					isTestInclude = true;
			// 				}
			// 			});
			// 			return isTestInclude;
			// 		})
			// 	}
			// 	let l = filteredGroups.length, s = this.pageSize;
			// 	return Math.ceil(l/s);
			// }
			pageCount(){
				let filteredGroups = this.paginatedGroups.filter(el => el.planName!=='(N/A)')
				// if(this.searchQuery) {
				// 	filteredGroups = filteredGroups.filter(g => {
				// 		if(g.planName.toLowerCase().includes(this.searchQuery.toLowerCase())){
				// 			return true;
				// 		}
				// 		let isTestInclude = false;
				// 		g.tests.map(t => {
				// 			if(t.URL.toLowerCase().includes(this.searchQuery.toLowerCase())){
				// 				isTestInclude = true;
				// 			}
				// 		});
				// 		return isTestInclude;
				// 	})
				// }
				let l = filteredGroups.length, s = this.pageSize;
				return Math.ceil(l/s);
			}
		},
		created(){
			if(this.status !== 'Up'){
				setInterval(() => this.startClockTicking(), 1000);
			}
		},
		methods: {
		  async openTicketModal(group){
		    this.$parent.$refs.ticketModal.load(this.presetMacros, group)
      },
		  getNoteTooltip(data){
		    let tooltip=''
		    if(data.noteAddedAt){
		      tooltip+=moment(data.noteAddedAt).format("DD MMM, YYYY HH:mm:ss")
        }
		    return tooltip
      },
      getRackName(name){
        if(name){
          let rack=name
          if(rack.includes('rack')){
            return rack.split('rack')[1]
          }else if(rack.includes('Rack')){
            return rack.split('Rack')[1]
          }
          else{
            return name
          }
        }
      },
      clickedIpSort () {
        if (!this.ipSortType) {
          this.ipSortType = 'desc'
        } else if (this.ipSortType === 'desc') {
          this.ipSortType = 'asc'
        } else {
          this.ipSortType = null
        }
      },
      clickedRackSort () {
        if (!this.rackSortType) {
          this.rackSortType = 'desc'
        } else if (this.rackSortType === 'desc') {
          this.rackSortType = 'asc'
        } else {
          this.rackSortType = null
        }
      },
      clickedNodeSort () {
        if (!this.nodeSortType) {
          this.nodeSortType = 'desc'
        } else if (this.nodeSortType === 'desc') {
          this.nodeSortType = 'asc'
        } else {
          this.nodeSortType = null
        }
      },
      clickedPlanSort () {
        if (!this.planSortType) {
          this.planSortType = 'desc'
        } else if (this.planSortType === 'desc') {
          this.planSortType = 'asc'
        } else {
          this.planSortType = null
        }
      },
      clickedStatusSort () {
        if (!this.statusSortType) {
          this.statusSortType = 'desc'
        } else if (this.statusSortType === 'desc') {
          this.statusSortType = 'asc'
        } else {
          this.statusSortType = null
        }
      },
      clickedOutageSort () {
        if (!this.outageSortType) {
          this.outageSortType = 'desc'
        } else if (this.outageSortType === 'desc') {
          this.outageSortType = 'asc'
        } else {
          this.outageSortType = null
        }
      },
      sort(field, type){
        console.log('inside sort')
        if(field=='planName'){
          if(type=='asc'){
             this.getWPOGroup=this.getWPOGroup.sort(function(a, b){
              // ASC  -> a.length - b.length
              // DESC -> b.length - a.length
              return a.planName.toLowerCase() > b.planName.toLowerCase() ? 1 : -1
            });

          }
          else {
            this.getWPOGroup=this.getWPOGroup.sort(function(a, b){
              // ASC  -> a.length - b.length
              // DESC -> b.length - a.length
              return b.planName.toLowerCase() > a.planName.toLowerCase() ? 1 : -1

            });
          }
        }
      },
      getTotalOutages(group){
        return group.tests.reduce((a, b) => a + (b.downCount || 0), 0);
      },
		  openAffectedNodesAndRacksModal(type){
		    this.$refs.nodes.load(type==='node' ? this.affectedNodes : this.affectedRacks, this.allNodes, type)
      },
      doCopy(item){
        this.$copyText(item).then(() => {
          this.$notify({
            group: 'foo',
            title: 'Message',
            text: 'Copied!'
          });
        }, function (e) {
          console.log(e)
        });
      },
		  async renderDatatable(group, type){
        group.showTests = !group.showTests
		    let self = this
		    if(type=='ungrouped'){
		      setTimeout(function () {
            $(`#${self.datatableId}-ungrouped`).dataTable({
              // pagingType: "full_numbers",
              "bPaginate": false, //hide pagination
              "bFilter": false, //hide Search bar
              destroy: true,
              retrieve: true,
              deferRender: true,
              stateSave: true,
              "bInfo" : false,
              "ordering": false,
              // order: [[2, "asc"]],
              // 'columnDefs': [ {
              //   'targets': [0,1, -1,7], /* column index */
              //   'orderable': false, /* true or false */
              // }]
            });
          }, 0)
        }
		    // else{
        //   group.showTests = !group.showTests
        //   let id=group.planName==='(N/A)' ? `${this.datatableId}-unavailable` : `${this.datatableId}-${group.planName}`
        //   if(id.includes('.com')){
        //     id= id.split('.')[0]
        //   }
        //   if(group.showTests){
        //     if($.fn.DataTable.isDataTable( `#${id}`)){
        //       $(`#${id}`).DataTable().destroy()
        //
        //     }
        //     $(`#${id}`).dataTable({
        //       pagingType: "full_numbers",
        //       destroy: true,
        //       retrieve: true,
        //       deferRender: true,
        //       stateSave: true,
        //       "ordering": true,
        //       order: [[2, "asc"]],
        //       'columnDefs': [ {
        //         'targets': [0,1, -1,7], /* column index */
        //         'orderable': false, /* true or false */
        //       }]
        //     });
        //   }
        // }

      },
		  async getAllNodes(){
		    try{
         let nodesResp=await  db.collection('nodes').get()
          this.allNodes= {}
          nodesResp.forEach( el => {
            this.allNodes[el.id] = el.data()
            // this.allNodes.push({id:el.id, ...el.data()})
          })
        }catch(e){
		      console.log('error', e.toString())
        }
      },
      nextPage(){
          this.pageNumber++;
      },
      prevPage(){
          this.pageNumber--;
      },
      goToPage(pageNum) {
          this.pageNumber = pageNum-1;
      },
			startClockTicking(){
				for(let test of this.tests){
					this.domainDateTime[test.URL] = this.timeDifferenceBetweenGivenDates(new Date().toISOString(), test.events[test.events.length-1].start);
					this.$forceUpdate();
				}
			},
			updateStatusCakeValue(test, e){
				console.log(e.target.value);
				console.log('Adding status cake value in: ' + test.testId);
				if(test.notes === undefined){
					test.notes = [];
				}
				test.notes.push({
					noteDate: new Date().toISOString(),
					note: e.target.value,
				});
				if (e.target.value === 'Suspended') {
          test.note = 'Suspended'
        }
				test.statusCake = e.target.value;
				test.updatedAt = new Date().toISOString();
				db.collection('status_cake_tests').doc(test.testId.toString())
						.update(test)
						.then(()=>{
							if(e.target.value === 'Active') {
								this.pause(test, 0);
							}else{
								this.pause(test, 1);
							}
						}).catch(() => {
                this.addLog({
                  message: `Error in updating status cake value!`,
                  level: "danger"
                })
							swal('Error', 'Error in updating status cake value!', 'error');
						});
			},
			openModal(test, el){
				if(el === 'viewEventsModal'){
					this.$parent.selectedItemForView = _.cloneDeep(test);
					this.$parent.selectedItemForView.events.reverse();
					if(this.$parent.selectedItemForView.notes !== undefined){
						this.$parent.selectedItemForView.notes.reverse();
					}
					let durations = [];
					for(let event of this.$parent.selectedItemForView.events){
						if(event.status === 'Down' && event.end !== undefined){
							let dur = this.timeDifferenceBetweenGivenDates(event.end, event.start);
							if(dur.split(':').length === 2){
								durations.push("00:" + dur);
							}else if(dur.split(':').length === 1){
								durations.push("00:00:" + dur);
							}else{
								durations.push(dur);
							}
						}
					}
					const totalDurations = moment.duration();
					durations.map(duration => {
						totalDurations.add(duration);
					});
					this.$parent.totalDownDurationOfSelectedItem = moment.utc(totalDurations.asMilliseconds()).format("HH:mm:ss");
				}else{
					this.$parent.selectedItemForView = test;
				}
				/* eslint-disable */
				$("#" + el).modal("show");
				$('.modal-backdrop').removeClass("modal-backdrop");
				/* eslint-enable */
			},
			pause(test, pauseValue) {
				this.updateItem = test;
				this.action = 'update';
				this.$http.post("domain/update/test", {
					grant_type: "token",
					token: this.userToken,
					data: {
						TestID: test.testId,
						Paused: pauseValue
					}
				})
					.then(() => {
						if(pauseValue === 0) {
							console.log('Un - Pausing....');
							this.$http.get('/status_cake/get_test?testId=' + test.testId).then(resp => {
								const testData = resp.data.test;
                if(!testData.ErrNo){
                  test.status = testData.Status;
                  test.events[test.events.length - 1].end = new Date().toISOString();
                  test.events.push({
                    start: new Date().toISOString(),
                    status: testData.Status,
                    statusCode: (testData.Status === 'Up') ? 200 : 0,
                  });
                  test.upTime = testData.Uptime;
                  test.updatedAt = new Date().toISOString();
                  if (testData.Status === 'Down') {
                    test.downCount += 1;
                  }
                }
								console.log(test);
								db.collection('status_cake_tests').doc(test.testId.toString()).update(test);

                this.addLog({
                  primaryPlan: 'Account Based Operation',
                  message: `Status cake test has been paused, TestId: ${test.testId}, Test Name: ${test.URL}`,
                  level: "info"
                })
							});
						}else{
							console.log('Pausing....');
							db.collection('status_cake_tests').doc(test.testId.toString()).update({ status: 'Paused' });
						}
					})
					.catch((err) => {
						console.error(err);
						let responseMessage = err.response.data.message;
						if (err.response.status === 422) {
							responseMessage = _.map(err.response.data.errors, 'msg').join('. ')
						} else if (err.response.status === 401) {
							responseMessage = "You need update token. Please Try Again!";
							this.refreshToken();
						}
						swal({
							title: "Something went wrong!",
							html: responseMessage,
							type: "error",
							confirmButtonText: "Try Again!",
							confirmButtonColor: "#EE8057"
						});
						this.addLog({
              primaryPlan: 'Account Based Operation',
							name: this.user.firstName + " " + this.user.lastName,
							message: "Error StatusCake pause. Message: " + responseMessage,
							level: "danger"
						});
					})
					.finally(() => {
						this.action = null;
						this.updateItem = null;
					});

			},
			remove(test, group) {
				swal({
					title: "Are you sure?",
					text: `Are you sure you want to delete this test?`,
					type: "question",
					confirmButtonText: "Yes Proceed",
					confirmButtonColor: "#6ACF98",
					showCancelButton: true,
					cancelButtonText: "No Thanks",
					cancelButtonColor: "#EE8057"
				})
					.then(result => {
						if (result.value) {
							this.removeItem = test;
							this.action = 'remove';

							this.$http.post("domain/delete/test", {
								grant_type: "token",
								token: this.userToken,
								testId: test.testId
							})
								.then(async() => {
									db.collection('status_cake_tests').doc(test.testId.toString()).delete();
                  await this.startGrouping();
                  this.addLog({
                    primaryPlan: 'Account Based Operation',
                    message: `StatusCake test has been deleted, TestId: ${test.testId}, Test Name: ${test.URL}`,
                    level: "info"
                  })
                  if (group) {
                    group.tests = group.tests.filter(t=> t.testId !== test.testId)
                  }
								})
								.catch((err) => {
									let responseMessage = err.response.data.message;
									if (err.response.status === 422) {
										responseMessage = _.map(err.response.data.errors, 'msg').join('. ')
									} else if (err.response.status === 401) {
										responseMessage = "You need update token. Please Try Again!";
										this.refreshToken();
									}
									swal({
										title: "Something went wrong!",
										html: responseMessage,
										type: "error",
										confirmButtonText: "Try Again!",
										confirmButtonColor: "#EE8057"
									});
									this.addLog({
                    primaryPlan: 'Account Based Operation',
										name: this.user.firstName + " " + this.user.lastName,
										message: "Error delete StatusCake test. Message: " + responseMessage,
										level: "danger"
									});
								})
								.finally(() => {
									this.action = null;
									this.removeItem = null;
								});
						}
					});
			},
			findUser(group){
				if (group.uid ) {
					// let customers = localStorage.getItem('customers') ? JSON.parse(localStorage.getItem('customers')) : [];
					// let user = find(customers, {'docID': uid});
					swal({
						title: group.firstName + ' ' + group.lastName,
						text: 'Would you like to login to this customer\'s WPO account',
						type: "question",
						confirmButtonText: "Yes Proceed",
						confirmButtonColor: "#6ACF98",
						showCancelButton: true,
						cancelButtonText: "No Thanks",
						cancelButtonColor: "#EE8057"
					}).then( result => {
						if(result.value){
							this.goToNuxt(group.uid);
						}
					});
				} else {
					swal("Not Found!", 'Plan is not found in the WPO', 'error');
				}
			},
      findOwnerOfDomain(test) {
  let domainName = '';
  let domain = '';
  try{
    domainName = new URL(test.URL);
    console.log(domainName.hostname.replace('www.', ''));
    domain = domainName.hostname.replace('www.', '');
  }catch (e) {
    // console.error(e);
    console.error('Error in URL Parsing: ' + test.URL);
    domain = test.URL;
  }
          let accountItems = localStorage.getItem('accounts') ? JSON.parse(localStorage.getItem('accounts')) : [];
          let userFound = {};
          map(accountItems, (item) => {
              item.accounts.map(account => {
                  if (account.primary.domain === domain) {
                      userFound = {uid: item.docID, isPrimary: true, plan: account.primary.domain};
                  }
                  account.addon.map(addon => {
                      if(addon.domain === domain){
                          userFound = {uid: item.docID, isPrimary: false, plan: account.primary.domain};
                      }
                  })
              })
          });
          return userFound;
      },
      getPausedAndDownTests(tests){
		    this.totalPausedTests=0
        this.totalDownTests=0
		    tests.map(el => {
		      if(el.status==='Paused'){
		        this.totalPausedTests++
          }
		      else if(el.status==='Down'){
		        this.totalDownTests++
          }
        })

      },
       async groupTestsInAPlan(testsToBeGrouped) {
        console.log('Start Grouping For: ' + this.status);
        this.tests = _.cloneDeep(testsToBeGrouped);
        console.log(this.tests);
        // paused and down
        this.getPausedAndDownTests(_.cloneDeep(this.tests))
        this.getAffectedNodes(_.cloneDeep(this.tests))
        this.getAffectedRacks(_.cloneDeep(this.tests))
        await this.getAllNodes();
        await this.startGrouping();
				// if(localStorage.getItem('accounts')) {
				// 	console.log('Start Grouping For: ' + this.status);
				// 	this.tests = _.cloneDeep(testsToBeGrouped);
				// 	console.log(this.tests);
				// 	this.startGrouping();
				// }else{
				// 	const intervalHandler = setInterval(() => {
				// 		if(!localStorage.getItem('accounts')) {
				// 			return;
				// 		}
				// 		console.log('Start Grouping For: ' + this.status);
				// 		this.tests = _.cloneDeep(testsToBeGrouped);
				// 		console.log(this.tests);
				// 		this.startGrouping();
				// 		console.log(`Interval Cleared ${this.status} ...`);
				// 		clearInterval(intervalHandler);
				// 	}, 1000);
				// }
            },
      getAffectedNodes(array){
		    this.affectedNodes=[]
		    if(array.length>0){
		      array.map(el => {
            if(el.nodeId){
              let obj=this.affectedNodes.find(row => row.id && row.id===el.nodeId)
              if(obj){
                obj.count++
              }
              else {
                this.affectedNodes.push({id: el.nodeId, count:1})
              }
            }
          })
        }
      },
      getAffectedRacks(array){
        this.affectedRacks=[]
        if(array.length>0){
          array.map(el => {
            if(el.rackId){
              let obj=this.affectedRacks.find(row => row.id && row.id===el.rackId)
              if(obj){
                obj.count++
              }
              else {
                this.affectedRacks.push({id: el.rackId, count:1, nodeId:el.nodeId || ''})
              }
            }
          })
        }
      },
			startGrouping () {
				this.tests.map(test => {
          console.log('alll nodes', this.allNodes)
					// const domainOwner = this.findOwnerOfDomain(test);
					const planName = (test.plan) ? test.plan : '(N/A)';
					let group = this.testGroups.find(g => g.planName === planName);
					if(!group) {
            console.log('testttttt', test)
						group = {
							planName:  planName,
							serverIp:  (planName === '(N/A)') ? '' :test.serverIP,
							uid: test.uid,
							firstName: test.firstName,
							lastName: test.lastName,
							tests: [test],
              nodeName: (this.allNodes[`${test.nodeId}`]) ? this.allNodes[`${test.nodeId}`].nodeName || '' : '',
              rackName: (this.allNodes[`${test.nodeId}`]) ? this.getRackName(this.allNodes[`${test.nodeId}`].rack_name) || '' : '',
							showTests: false,
							downCount: (test.status === 'Down') ? 1 : 0,
							pauseCount: (test.status === 'Paused') ? 1 : 0,
						};
						this.testGroups.push(group);
					} else if(group){
						const testExist = group.tests.find(t => (t.testId === test.testId));
						if(!testExist) {
							group.tests.push(test);
							if (test.status === 'Down') {
								group.downCount += 1;
							} else if (test.status === 'Paused') {
								group.pauseCount += 1;
							}
						}else if(testExist && testExist.status !== test.status) {
							testExist.status = test.status;
							if(test.status === 'Down'){
								group.pauseCount -= 1;
								group.downCount += 1;
							} else if (testExist.status === 'Paused') {
								group.pauseCount += 1;
								group.downCount -= 1;
							}
						}
						group.tests.map(groupTest => {
							const groupTestIsExist = this.tests.find(t => t.testId === groupTest.testId);
							if(!groupTestIsExist){
								if(groupTest.status === 'Down'){
									group.downCount -= 1;
								}else if(groupTest.status === 'Paused') {
									group.pauseCount -= 1;
								}
								group.tests = group.tests.filter(t => t.testId !== groupTest.testId);
							}
						})
					}
				});
				this.testGroups.map(g => {
					if(g.tests.length === 1) {
						const isLastTestExist = this.tests.find(t => t.testId === g.tests[0].testId);
						if(!isLastTestExist) {
							this.testGroups = this.testGroups.filter(g1 => g1.planName !== g.planName);
						}
						g.downCounts=g.tests[0].downCount
					}else{
					  g.downCounts= this.getTotalOutages(g)
          }
					g.status=g.tests.find(el => el.status==='down') ? 'down' : 'paused'
				});
				if(this.status !== 'Up') {
                    // this.testGroups.sort((group1, group2) => (group1.downCount < group2.downCount) ? 1 : -1);
                    this.testGroups = _.orderBy(this.testGroups, ['downCount'], ['desc']);
        }
        this.loading = false
				// let tempArray=[]
				// this.testGroups.map(el => {
				//   if(el.tests.length>1){
        //     tempArray.push(el )
        //   }
				//   else {
				//     let obj = tempArray.find(el => el.ungrouped==true)
        //     if(obj){
        //       let existingTest= obj.tests.find(el1=> el1.testId===el.tests[0].testId)
        //       if(existingTest){
        //         existingTest.status= el.tests[0].status
        //         if(el.tests[0].status==='Down' && existingTest.status==='Paused'){
        //           obj.downCount=  obj.downCount+1
        //           obj.pauseCount= obj.pauseCount-1
        //         }
        //         else  if(el.tests[0].status==='Paused' && existingTest.status==='Down'){
        //           obj.downCount=  obj.downCount-1
        //           obj.pauseCount= obj.pauseCount+1
        //         }
        //       }else {
        //         obj.downCount= el.tests[0].status==='Down' ? obj.downCount+1 : obj.downCount
        //         obj.pauseCount= el.tests[0].status==='Paused' ? obj.pauseCount+1 : obj.pauseCount
        //         obj.tests.push(el.tests[0])
        //       }
        //     }
				//   else {
				//     tempArray.push({
        //       ungrouped: true,
        //       showTests: false,
        //       planName: 'ungrouped',
        //       downCount: el.tests && el.tests[0] && el.tests[0].status==='Down' ? 1 : 0,
        //       pauseCount: el.tests && el.tests[0] && el.tests[0].status==='Paused' ? 1 : 0,
        //       tests: (el.tests && el.tests[0]) ? [el.tests[0]] : []
        //     })
        //     }
        //   }
        // })
        // this.testGroups=tempArray
        this.renderDatatable({}, 'ungrouped')
			}
		}
	}
</script>

<style>
.dropdown-toggle:after {
  display: none;
}
	.sc-status {
		width: 20px;
		border-radius: 50%;
		height: 20px;
		display: inline-block;
	}

	.sc-status.down {
		background-color: #a51f1f;
	}

	.sc-status.up {
		background-color: #6aa529;
	}

	.sc-status.pause{
		background-color: #f29f3f;
	}

	.details-control {
		background: url('../../../assets/img/details_open.png') no-repeat center center;
		cursor: pointer;
		width: 20px;
		height: 20px;
		display: block;
		margin: 13px auto;
	}

	.details-control.shown {
		background: url('../../../assets/img/details_close.png') no-repeat center center;
	}
	.single-outage-table tr > th,td{
		padding: 4px 7px !important;
	}
	.single-outage-table tr > th{
		font-size: 12px !important;
		font-weight: 400 !important;
	}
	code{
		color: #007bff !important;
	}
	.eventsTable tbody tr td{
		padding-top: 5px !important;
		padding-bottom: 5px !important;
	}
	.notesTable tbody tr td{
		padding-top: 5px !important;
		padding-bottom: 5px !important;
	}
	.lh-3{
		line-height: 3;
	}
	.group-section{
		background: #f4f4f4;
	}
	.pagination{
		display: inline-flex !important;
	}
  .cursor-pointer {
    cursor: pointer !important;
  }
  .datatable-dropdown{
    width: 75px;
  }
  .badge.p-4-4{
    padding: 3px 3px !important;
    border-radius: 0px;
  }
</style>
